module.exports = __webpack_public_path__ + "static/media/notification.b27e9a3e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notification.svg
// module id = 1012
// module chunks = 1